import axiosInstance from "api/axiosInstance"
import SAlert from "components/Alert"
import { shipmentAction } from "./shipment-slice"
import { batch } from "react-redux"
import exportAxiosInstance from "api/exportAxiosInstance"
import FileSaver from "file-saver"

export const getShipments =
  (
    url,
    pageNumber = 10,
    according = { order: "desc", name: "id" },
    search = null
  ) =>
  dispatch => {
    dispatch(shipmentAction.setLoading(true))
    url = url || "/v1/shipments"
    axiosInstance
      .get(url, {
        params: {
          pageNumber,
          according,
          search,
        },
      })
      .then(response => {
        if (response) {
          batch(() => {
            dispatch(shipmentAction.setError(null))
            dispatch(shipmentAction.setData(response.data))
            dispatch(shipmentAction.setLoading(false))
          })
        }
      })
      .catch(() => {
        dispatch(shipmentAction.setLoading(false))
      })
  }

export const deleteShipment = id => dispatch => {
  dispatch(shipmentAction.setLoading(true))
  axiosInstance
    .delete(`/v1/shipments/${id}`)
    .then(() => {
      dispatch(getShipments())
      SAlert({
        title: "Success",
        text: "Shipment successfully deleted",
      })
      batch(() => {
        dispatch(shipmentAction.setError(null))
        dispatch(shipmentAction.setLoading(false))
      })
    })
    .catch(() => {
      dispatch(shipmentAction.setLoading(false))
    })
}

export const storeShipment = (data, navigate) => dispatch => {
  dispatch(shipmentAction.setLoading(true))
  axiosInstance
    .post("/v1/shipments", data)
    .then(() => {
      navigate("/shipments")
      SAlert({
        title: "Success",
        text: "Shipment successfully inserted",
      })
      batch(() => {
        dispatch(shipmentAction.setError(null))
        dispatch(shipmentAction.setLoading(false))
      })
    })
    .catch(err => {
      dispatch(shipmentAction.setLoading(false))
      dispatch(shipmentAction.setError(err?.response?.data?.errors))
    })
}

export const updateShipment = (id, data, navigate) => dispatch => {
  dispatch(shipmentAction.setLoading(true))
  axiosInstance
    .put(`/v1/shipments/${id}`, data)
    .then(() => {
      navigate("/shipments")
      SAlert({
        title: "Success",
        text: "Shipment successfully updated",
      })
      batch(() => {
        dispatch(shipmentAction.setError(null))
        dispatch(shipmentAction.setLoading(false))
      })
    })
    .catch(error => {
      dispatch(shipmentAction.setLoading(false))
      dispatch(shipmentAction.setError(error?.response?.data?.errors))
    })
}

export const getByIdShipment = id => dispatch => {
  dispatch(shipmentAction.setLoading(true))
  axiosInstance
    .get(`/v1/shipments/${id}`)
    .then(response => {
      batch(() => {
        dispatch(shipmentAction.setError(null))
        dispatch(shipmentAction.setLoading(false))
        dispatch(shipmentAction.setShipment(response.data))
      })
    })
    .catch(() => {
      dispatch(shipmentAction.setLoading(false))
    })
}

export const exportShipments = search => dispatch => {
  dispatch(
    shipmentAction.setExportStatus({
      loading: true,
      error: null,
    })
  )
  exportAxiosInstance
    .get("/v1/shipments-export", {
      params: { search },
    })
    .then(response => {
      if (response) {
        const dataBlob = new Blob([response?.data], {
          type: "application/pdf,",
        })
        FileSaver.saveAs(
          dataBlob,
          `Shipments-${Math.random().toString()}.xlsx`
        )
        dispatch(
          shipmentAction.setExportStatus({
            loading: false,
            error: null,
          })
        )
      }
    })
    .catch(error => {
      dispatch(
        shipmentAction.setExportStatus({
          loading: false,
          error: error?.response?.errors,
        })
      )
    })
}
